export default __webpack_public_path__ + "static/media/scholar-instruction-image-mobile.f4254524.svg";